import React, { useState, useEffect } from 'react';
import './RelayControl.css';
import ContentWrapper from './ContentWrapper';
import UniformTable from './UniformTable';
import RelayControlDetail from './RelayControlList';

export default function RelayControl({ devices = [] }) {
  const [selectedImei, setSelectedImei] = useState(null);
  const [query, setQuery] = useState('');
 useEffect(() => {                              
    const handlePopState = () => {
      const match = window.location.pathname.match(/^\/relay-control\/(.+)$/);
      setSelectedImei(match ? match[1] : null);
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  if (selectedImei) {
    return (
      <RelayControlDetail 
        imei={selectedImei} 
        onBack={() => window.history.back()} 
      />
    );
  }
if (selectedImei) {
  return (
    <RelayControlDetail 
      imei={selectedImei} 
      onBack={() => window.history.back()} 
    />
  );
}

  const filtered = query.trim() === '' 
    ? devices 
    : devices.filter(d => 
        String(d.name || d.deviceName || '').toLowerCase().includes(query.toLowerCase()) ||
        String(d.imei || '').includes(query)
      );

  const columns = [
    { header: '#', accessor: 'number' },
    { header: 'Name', accessor: 'name' },
    { header: 'IMEI', accessor: 'imei' },
    { header: 'Action', accessor: 'action', align: 'center' }
  ];

  const rows = filtered.map((d, i) => ({
    number: (
      <span className="devices-badge fleet-table-index">
        {String(i + 1).padStart(2, '0')}
      </span>
    ),
    name: d.name || d.deviceName || 'Device',
    imei: <span className="mono">{d.imei || '-'}</span>,
    action: (
      <div style={{ textAlign: 'center' }}>
        <button className="btn-track" onClick={() => {
  setSelectedImei(d.imei);
  window.history.pushState({}, '', `/relay-control/${d.imei}`);
}}>
  Control Relay
</button>
      </div>
    )
  }));

  return (
    <ContentWrapper title="Relay Control">
      <div className="devices-container">
        <div className="devices-desktop">
          <div className="devices-header-row">
            <input 
              className="devices-search-input" 
              type="text" 
              placeholder="Search name, IMEI…" 
              value={query} 
              onChange={e => setQuery(e.target.value)} 
            />
          </div>

          <div className="devices-table-container fleet-table-wrapper">
            {rows.length === 0 ? (
              <div className="align-center fleet-table-empty">No devices found</div>
            ) : (
              <UniformTable columns={columns} data={rows} />
            )}
          </div>
        </div>

      <div className="devices-mobile">
        <div className="devices-header-row">
          <input 
            className="devices-search-input" 
            type="text" 
            placeholder="Search name, IMEI…" 
            value={query} 
            onChange={e => setQuery(e.target.value)} 
          />
        </div>

        {filtered.length === 0 ? (
          <div className="align-center" style={{ padding: '40px', color: '#64748b' }}>
            No devices found
          </div>
        ) : (
          filtered.map((d, i) => (
            <div key={d.imei || d.id || i} className="mobile-device-card">
              <div className="mobile-device-card-header">
                <h3 className="mobile-device-name">{d.name || d.deviceName || 'Device'}</h3>
                <span className="devices-badge">{String(i + 1).padStart(2, '0')}</span>
              </div>
              <div className="mobile-device-card-body">
                <div className="mobile-device-info-row">
                  <span className="mobile-info-label">IMEI</span>
                  <span className="mobile-info-value mono">{d.imei || '-'}</span>
                </div>
              </div>
              <div className="mobile-device-actions">
                <button className="btn-track" onClick={() => {
  setSelectedImei(d.imei);
  window.history.pushState({}, '', `/relay-control/${d.imei}`);
}}>
  Control Relay
</button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  </ContentWrapper>
  );
}